import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  updateProjectItemFieldValueMutation,
  updateProjectItemFieldValueMutation$data,
  UpdateProjectV2ItemFieldValueInput,
} from './__generated__/updateProjectItemFieldValueMutation.graphql'

export function commitUpdateProjectItemFieldValueMutation({
  environment,
  input,
  onError,
  onCompleted,
}: {
  environment: Environment
  input: UpdateProjectV2ItemFieldValueInput
  onError?: (error: Error) => void
  onCompleted?: (response: updateProjectItemFieldValueMutation$data) => void
}) {
  return commitMutation<updateProjectItemFieldValueMutation>(environment, {
    mutation: graphql`
      mutation updateProjectItemFieldValueMutation($input: UpdateProjectV2ItemFieldValueInput!) @raw_response_type {
        updateProjectV2ItemFieldValue(input: $input) {
          projectV2Item {
            id
            type
            project {
              id
            }
            fieldValues(first: 50, orderBy: {field: POSITION, direction: ASC}) {
              edges {
                ... on ProjectV2ItemFieldValueEdge {
                  node {
                    ...TextFieldFragment
                    ...NumberFieldFragment
                    ...DateFieldFragment
                    ...SingleSelectFieldFragment
                    ...IterationFieldFragment
                  }
                }
              }
            }
            fieldValueByName(name: "Status") {
              ... on ProjectV2ItemFieldSingleSelectValue {
                name
              }
            }
          }
        }
      }
    `,
    variables: {
      input,
    },
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
  })
}
